import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Button } from "antd";
export class PaySuccess extends Component {
  static propTypes = {
    pay: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    payType: -1,//0支付宝 1微信 2建行 3聚合扫码 4免费开通
  }
  componentDidMount() {
    let path = this.props.history.location.pathname;
    let pathArr = path.split("/");
    let orderId = pathArr[3];
    let payType = parseInt(pathArr[2], 10);
    this.setState({
      payType,
    }, () => {
      //获取订单详情
      this.props.actions.fetchGetOrderPayById({
        orderId,
      })
    })
  }
  render() {
    const { fetchGetOrderPayByIdSuccess } = this.props.pay;
    const { payType } = this.state;
    //'studentinfo' is assigned a value but never used
    //let studentinfo = JSON.parse(localStorage.getItem("studentinfo"));
    return (
      <div className="pay-pay-success">
        <div className="banner">
          <h1>支付成功</h1>
        </div>
        <div className="pay-success-detail">
          <div className="success-img">
            <img src={require("../../images/paySuccess.png")} alt="" />
            <p>恭喜你！{payType === 4 ? "开通" : "支付"}成功！</p>
          </div>
          {
            fetchGetOrderPayByIdSuccess && <table className="success-detail">
              <tbody>
                <tr>
                  <td>
                    <span>支付方式:</span>
                    <span>{payType === 0 ? "支付宝支付" : payType === 1 ? "微信支付" : payType === 2 ? "建设银行支付" : payType === 3 ? "聚合扫码支付" : "免费开通"}</span>
                  </td>
                  <td>
                    <span>订单编号:</span>
                    <span>{fetchGetOrderPayByIdSuccess.OrderNo}</span>
                  </td>
                </tr>
                <tr>
                  {/* <td>
                    <span>支付账号:</span>
                    <span>{studentinfo.Name || "未知"}</span>
                  </td> */}
                  <td>
                    <span>支付金额:</span>
                    <span>¥{fetchGetOrderPayByIdSuccess.UsedPrice > 0 ? (fetchGetOrderPayByIdSuccess.Price - fetchGetOrderPayByIdSuccess.UsedPrice).toFixed(2) : fetchGetOrderPayByIdSuccess.Price.toFixed(2)}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          }
          <div className="btns">
            <Button type="theme" onClick={() => this.props.history.push('/center/myOrder/0')}>返回列表</Button>
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pay: state.pay,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaySuccess);



// WEBPACK FOOTER //
// ./src/features/pay/PaySuccess.js